import { Component, Element, State, Watch, Event, EventEmitter } from '@stencil/core';
import { TiResponsive, TiResponsiveHandler, TiResponsiveViewport } from '@ticom/web-component-utils';

@Component({
    tag: 'ti-search-viewport-tracker',
    shadow: false
})
export class SearchViewportTracker implements TiResponsive {

    @TiResponsiveHandler()
    @Element() hostElement: HTMLTiSearchViewportTrackerElement;

    @Event() viewportSizeChange: EventEmitter;

    @State() viewportSize: TiResponsiveViewport = TiResponsiveViewport.desktop;
    @Watch('viewportSize')
    handleViewportSizeChange(viewportSize: TiResponsiveViewport) {
        this.viewportSizeChange.emit({
            viewportSize: viewportSize
        });
    }

    componentWillLoad() {
        // required by TiResponsive interface
    }

    disconnectedCallback() {
        // required by TiResponsive interface
    }

    render() {
        (window as any).tiViewType = this.viewportSize;
    }
}
